import type { Role } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { isImpersonating } from '@adornis/users/client/currentUser.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { AdornisUser, stopImpersonationOfUser } from '@adornis/users/db/a-user.js';
import { html, nothing } from 'lit';
import smartteamLogo from '../assets/smartteam-logo.png';

export const Topbar = stateful(
  ({ user, userRoles, version }: { user: AdornisUser; userRoles: Role[]; version?: string }) => {
  const impersonating = useObservable(() => isImpersonating, []);

  return html`
    <!-- Impersonation Banner -->
    ${impersonating
      ? html`
          <div class="bg-warning text-warning-content px-4 py-2 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <span class="icon-[mdi--account-switch] text-xl"></span>
              <span class="text-sm font-medium">
                You are logged in as <strong>${user?.email ?? 'another user'}</strong> (Impersonation active)
              </span>
            </div>
            <button class="btn btn-sm btn-ghost" @click=${() => stopImpersonationOfUser()()}>
              <span class="icon-[mdi--logout] text-lg"></span>
              End impersonation
            </button>
          </div>
        `
      : nothing}

    <nav class="navbar bg-base-100 shadow-md border-b border-neutral/10 sticky top-0 z-10">
      <div class="flex-1 px-6">
        <img src=${smartteamLogo} alt="SmartTeam" class="h-9 w-auto" />
      </div>
      <div class="px-6 flex items-center gap-4">
        <!-- User roles badges -->
        <div class="flex items-center gap-1">
          ${userRoles.length > 0
            ? userRoles.map(role => html`<span class="badge badge-primary badge-sm">${role.roleName}</span>`)
            : html`<span class="badge badge-ghost badge-sm">No role</span>`}
          ${version ? html`<span class="badge badge-ghost badge-sm">v${version}</span>` : nothing}
        </div>
        <span class="text-sm text-base-content/60">${user?.email ?? ''}</span>
        <button class="btn btn-ghost btn-circle" @click=${() => logout()} aria-label="Logout">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
        </button>
      </div>
    </nav>
  `;
});
